import { colors } from '../foundation';

type Props = {
  color?: (typeof colors.red)[100] | typeof colors.primary.white;
};

const FacebookIcon = ({ color = colors.primary.white }: Props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.25 11.9236C23.2497 9.77374 22.6334 7.669 21.474 5.85853C20.3147 4.04807 18.6608 2.6077 16.7083 1.70795C14.7558 0.808202 12.5864 0.486745 10.4568 0.781639C8.32731 1.07653 6.32687 1.97543 4.69233 3.37191C3.0578 4.76839 1.85762 6.60397 1.23389 8.66135C0.610155 10.7187 0.588985 12.9118 1.17288 14.9808C1.75678 17.0498 2.9213 18.9082 4.52857 20.336C6.13584 21.7638 8.11856 22.7011 10.242 23.0371V15.1752H7.3875V11.9236H10.2435V9.44484C10.2435 6.62522 11.9235 5.06784 14.4926 5.06784C15.3363 5.07955 16.1781 5.15287 17.0111 5.28722V8.05622H15.591C15.3492 8.02434 15.1034 8.04721 14.8716 8.12315C14.6399 8.19909 14.4282 8.32615 14.2521 8.49494C14.0761 8.66373 13.9403 8.86992 13.8547 9.09828C13.7691 9.32664 13.7359 9.57131 13.7576 9.81422V11.9236H16.8784L16.3793 15.1752H13.7576V23.0371C16.4041 22.6185 18.8142 21.2691 20.5544 19.2318C22.2945 17.1944 23.2504 14.6029 23.25 11.9236Z"
      fill={color}
    />
  </svg>
);

export default FacebookIcon;
